<template>
  <div class="wrapper">
    <header-component></header-component>
    <menu-component></menu-component>   
    <watch-component></watch-component>
    <router-view style="margin-top: 10rem;"></router-view>
    <footer-component></footer-component>
  </div>
</template>



<script>
import HeaderComponent from "./Header";
import MenuComponent from "./Menu";
import FooterComponent from "./Footer";
import WatchComponent from "./WatchCarousel.vue";

export default {
  components: {
    HeaderComponent,
    MenuComponent,
    FooterComponent,
    WatchComponent
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Home.vue